<template>
	<div class="forumSearchBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<img src="../../assets/img/myicon/indexBgc02.png" alt="" class="backImg">
				<!-- <div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">帖子搜索结果</p>
				</div> -->
				<div class="searchBox">
					<div class="leftArr" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<!-- 右侧 -->
					<div class="search">
						<div class="selectBox">
							<div class="searchValBox">
								<input type="text" v-model="inputVal" value="" :placeholder="keyword" @keyup.13="seachPageResult(inputVal)" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</van-sticky>
		<div class="listBox">
			<div class="listBox_chid" v-if="categoryDetailList.length != 0 ? true:false">
				<!--  @click="jumpUrlBKM(item.id)" -->
				<div class="listBoxItem" v-for="(item,idx) in categoryDetailList" :key="idx">
					<div class="listBoxItem_top">
						<p>{{item.title}}
							<img src="../../assets/img/new_zd.png" alt="" v-if="item.is_top == 1">
							<img src="../../assets/img/new_jp.png" alt="" v-if="item.is_digest == 1">
						</p>
					</div>
					<div class="listBoxItem_bottom">
						<div class="listBoxItem_bottom_left">
							<img :src="$api.$BASE_URL_img + anonymous_url[Math.floor(Math.random()*3)]" alt="" v-if="item.anonymous == 1"/>
							<img :src="$api.$BASE_URL_img + item.avatar" alt="" v-else/>
							<span class="penName" v-if="item.anonymous == 1">{{anonymous_name[Math.floor(Math.random()*6)]}}</span>
							<span class="penName" v-else>{{item.nickname}}</span>
							<p class="timeData"><span>{{formatDateTime(item.createtime)}}</span></p>
						</div>
						<div class="listBoxItem_bottom_right">
							<img src="../../assets/img/ltxiaoxi.png" alt="">
							<p>{{item.comment_num}}</p>
						</div>
					</div>
				</div>
			</div>
			<div class="data_null" v-if="categoryDetailList.length == 0 ? true:false">
				<img src="../../assets/img/data_null.png" alt="">
			</div>
		</div>

	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				inputVal: '',
				keyword: '',
				typeTxt: '',
				categoryDetailList: [],
				anonymous_name:['匿名用户1','匿名用户2','匿名用户3','匿名用户4','匿名用户5','匿名用户6'],
				anonymous_url: ['/uploads/20200331/b6aa12415d510ad363ef17ac77aa0e2c.jpg','/uploads/20200331/62335b1ebab479e0a06b4cbd83b6681a.jpg','/uploads/20200331/027821507b7353583a744b71162e67df.jpg']
			}
		},
		created() {
			this.inputVal = this.$route.query.keyword;
			this.seachPageResult(this.inputVal)
		},
		methods: {
			seachPageResult(val) {
				this.inputVal = val;
				this.$axios.post(this.$api.search_forum, {
					keywords: this.inputVal,
					type: this.type,
					status: this.$route.query.status,
				}).then(res => {
					Toast(res.data.msg);
					this.categoryDetailList = res.data.data.list;
				})

			},
			back(){
				this.$router.push({path:'/forum',query:{tit_tabActive: this.$route.query.status}})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);

				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.forumSearchBox {
		background-color: #fff;
		height: 100vh;
		width: 100vw;
	}

	.data_null {
		img {
			position: fixed;
			top: 30%;
			left: 50%;
			transform: translate(-50%, -30%);
			width: 200px;
		}
	}

	// 头部
	.headerBox {
		display: flex;
		height: 160px;
		background-color: #fff;
		position: relative;
		
		.backImg{
			position: absolute;
			bottom: 10px;
			left:0;
			width:100%;
		}

		.searchBox {
			position: relative;
			margin-top: 70px;
			width: 100%;
			border-bottom: 1px solid #f0f0f0;

			.leftArr {
				img {
					position: absolute;
					top: 50%;
					left: 0px;
					transform: translateY(-50%);
					width: 40px;
					height: 40px;
				}
			}

			// padding: 0 40px;
			.search {
				background: rgba(0,0,0,0.05);
				border-radius: 50px;
				width: 90vw;
				position: absolute;
				top: 50%;
				left: 60px;
				transform: translateY(-50%);

				.selectBox {
					position: relative;
					width: 80vw;
					height: 60px;
					display: flex;

					.searchValBox {
						flex: 1;
						line-height: 60px;

						input {
							width: 90%;
							padding-left: 20px;
							background-color: transparent;
						}
					}
				}
			}
		}

	}

	//列表
	.listBox {
		padding: 0 35px;
		background-color: #fff;
		height: calc(100vh - 470px);
		overflow: hidden;

		.listBox_chid {
			height: calc(100vh - 470px);
			overflow-y: scroll;
		}

		.listBoxItem {
			border-bottom: 1px solid #f0f0f0;

			/*no*/
			.listBoxItem_top {
				position: relative;
				padding-top: 20px;

				p {
					font-size: 28px;

					/*px*/
					span {
						line-height: 0px;
						/*px*/
						padding: 20px 25px;
						display: inline-block;
						border-radius: 8px;
						font-size: 24px;
						/*px*/
					}

					span:last-child {
						margin-left: 20px;
					}

					span.dz {
						color: #ff9470;
						border: 1px solid #ff9470;
						/*no*/
					}

					span.jh {
						color: #fa7298;
						border: 1px solid #fa7298;
						/*no*/
					}
				}
				
				img{
					display: inline-block;
					width:40px;
					height:40px;
					margin-left: 20px;
				}

			}

			.listBoxItem_bottom {
				display: flex;
				height: 40px;
				/*no*/

				.listBoxItem_bottom_left {
					flex: 1;
					color: #a3a3a3;
					line-height: 40px;

					/*no*/
					img {
						width: 40px;
						height:40px;
						box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.4);
						vertical-align: middle;
						border-radius: 50%;
						margin-left: 6px;
					}

					.timeData {
						display: inline-block;
						font-size: 24px;

						/*px*/
						.time {
							padding-left: 10px;
						}
					}

					.penName {
						padding: 0 20px;
						font-size: 24px;
						/*px*/
					}
				}

				.listBoxItem_bottom_right {
					width: 100px;
					text-align: right;

					img {
						width: 35px;
						padding-top: 15px;
						padding-right: 10px;
					}

					p {
						padding-right: 15px;
					}
				}
			}
		}
	}
</style>
